/**
 * Single source of truth for the operational-health ("RMP") API origin that
 * backs the market, store, service and trend views.
 *
 * Shared source, so it must build for BOTH targets:
 *   - Nerdpack: always uses DEFAULT_HEALTH_API_BASE. The New Relic webpack build
 *     has no build-time env injection and there is no config.json, so the
 *     origin is fixed at build time.
 *   - Standalone: may override the origin at runtime without a rebuild. The
 *     entry point (src/main.jsx) resolves a value from config.json / VITE_* /
 *     localStorage (see src/runtime-config.js) and publishes it on globalThis
 *     under HEALTH_API_BASE_GLOBAL, which getHealthApiBase() reads here.
 *
 * A global is used rather than importing the standalone-only runtime-config
 * module so this file stays inside the shared tree and avoids the build-time
 * env references the shared-source gate forbids.
 */

export const DEFAULT_HEALTH_API_BASE =
  "https://xbzpe5g7i2ibwqyuwlw2uszjva0zhtqq.lambda-url.us-east-1.on.aws";

/** Key the standalone entry point sets on globalThis. Never set in a nerdpack. */
export const HEALTH_API_BASE_GLOBAL = "__healthDashboardHealthApiBase";

/**
 * Resolve the health API origin, without a trailing slash so callers can safely
 * append paths that begin with "/". Falls back to the compiled default whenever
 * no valid runtime override is present (always the case inside a nerdpack).
 */
export function getHealthApiBase() {
  const scope = typeof globalThis !== "undefined" ? globalThis : undefined;
  const override = scope ? scope[HEALTH_API_BASE_GLOBAL] : undefined;
  const base =
    typeof override === "string" && override.length > 0
      ? override
      : DEFAULT_HEALTH_API_BASE;
  return base.replace(/\/+$/, "");
}
